import React from 'react';
import { OfferBlock } from './OfferBlock';
const steps = ['Recognize the signal.', 'Pause when appropriate.', 'Reassess the situation.', 'Make a more structured decision.'];
export function FinalCta() {
  return <section className="bg-navy-900 px-5 py-16 sm:py-24" aria-labelledby="final-title" data-id="element-138" data-mp="19g0b5d63bmhs">
      <div className="mx-auto max-w-2xl text-center" data-id="element-139" data-mp="15d3zk6eywqnc">
        <h2 id="final-title" className="font-display text-4xl font-bold uppercase leading-tight text-white sm:text-5xl" data-id="element-140" data-mp="15fq9gcpbzi8q">
          Ready to stop relying on <span className="text-radar" data-id="element-141" data-mp="1ed0kpy25f7dn">"I hope nothing goes wrong"?</span>
        </h2>
        <p className="mt-5 text-lg leading-relaxed text-white/85" data-id="element-142" data-mp="1t3g9tnxoqzh3">
          Start recognizing the warning signs before they become bigger problems. You don't need another enormous
          textbook. You need a system that helps you ask the right questions when something doesn't look routine.
        </p>

        <ol className="mx-auto mt-8 max-w-md space-y-2 text-left" data-id="element-143" data-mp="1x5b8eko8eyr6">
          {steps.map((s, i) => <li key={s} className="flex items-center gap-3 text-lg font-semibold text-white" data-id="element-144" data-mp="n6nul8d98n1j" data-mpi={i}>
              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-radar font-display text-navy-950" data-id="element-145" data-mp="s3w4klo91krp">
                {i + 1}
              </span>
              {s}
            </li>)}
        </ol>

        <p className="mt-8 text-white/80" data-id="element-146" data-mp="1246i67e74u7e">That's what Implant Risk Radar™ was built for.</p>
        <p className="mt-6 text-sm font-bold uppercase tracking-widest text-radar" data-id="element-147" data-mp="163xcum6ufuh7">Only</p>
        <p className="font-display text-7xl font-bold leading-none text-white" data-id="element-148" data-mp="1b28lwupbe0yd">
          $27 <span className="text-3xl text-radar" data-id="element-149" data-mp="1fvbaeof8ik7p">USD</span>
        </p>

        <div className="mt-8" data-id="element-150" data-mp="1kt3aw6ty3eni">
          <OfferBlock tone="dark" label="Get Implant Risk Radar™ today" meta="One-time payment · Immediate digital access · Lifetime access · 7-Day Guarantee" data-id="element-151" data-mp="1ksbhn2ntlt0e" />
        </div>
      </div>
    </section>;
}